import Promise from 'bluebird';
import fetch from 'utils/fetch';
import formEncode from 'form-urlencoded';
import decamelize from 'decamelize';
import {getFromMeta} from 'utils/shareResourceToken';
import Request from './Request';
import * as responseHandlers from './responseHandlers';
import * as actionTypes from './actionTypes';
import {PUT, POST} from './methods';
import {PRODUCTION} from 'utils/env';

function routeResponse(request, response) {
  const statusCode = response.status;
  const responseHandler = responseHandlers[`handle${statusCode}`];
  let promise = null;

  if (responseHandler) {
    promise = responseHandler(request, response);
  } else {
    promise = Promise.resolve({
      type: actionTypes.RESPONSE_UNHANDLED_STATUS_CODE,
      request,
      response,
    });
  }

  return promise;
}

export function encodeRecordToBody(record) {
  const neverEncodeKeys = ['link'];
  const mapped = record
    .toMap()
    .mapEntries((entry) => {
      return [decamelize(entry[0], '_'), (entry[1] && entry[1].toJS) ? entry[1].toJS() : entry[1]];
    })
    .filterNot((value, key) => {
      return value === null || ~neverEncodeKeys.indexOf(key);
    });

  return formEncode(mapped.toJS());
}

function makeRequest(dispatch, request) {
  const {url, method, record} = request;
  const fetchOptions = {
    url,
    method,
    headers: {},
  };
  const shareResourceToken = getFromMeta();
  const isNewOrUpdate = ~[PUT, POST].indexOf(request.method);

  if (!PRODUCTION && !record && isNewOrUpdate) {
    console.warn('A request was created as a POST or PUT but no associated record was found. This will fail to add or update any new records in existing representations.');
  }

  if (shareResourceToken) {
    fetchOptions.headers.Authorization = `Bearer ${shareResourceToken}`;
  }

  if (record && isNewOrUpdate) {
    fetchOptions.body = encodeRecordToBody(record);
    fetchOptions.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
  }

  return fetch(`/${url.join('/')}`, fetchOptions)
    .then((response) => {
      return routeResponse(request, response)
        .then((action) => {
          return dispatch(action);
        });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.REQUEST_UNCAUGHT_ERROR,
        request,
        error,
      });

      if (!PRODUCTION) {
        throw error;
      }
    });
}

export function queueRequests(requests) {
  return (dispatch) => {
    const fetches = [];

    try {
      for (const request of requests) {
        dispatch({
          type: actionTypes.REQUEST_QUEUED,
          request,
        });

        fetches.push(makeRequest(dispatch, request));
      }
    } catch (error) {
      dispatch({
        type: actionTypes.REQUEST_UNCAUGHT_ERROR,
        requests,
        error,
      });

      if (!PRODUCTION) {
        throw error;
      }
    }

    return Promise.all(fetches);
  };
}

export function refreshRecord(record) {
  return (dispatch) => {
    const request = new Request({
      url: record.link,
      useCache: false,
    });

    dispatch({
      type: actionTypes.REQUEST_QUEUED,
      request,
    });

    makeRequest(dispatch, request);
  };
}



// WEBPACK FOOTER //
// ./app/javascript/requests/actions.js